import { useCopilotKit } from "@copilotkit/react-core/v2";
import { useEffect, useState } from "react";
import { APPS_REDEEM_AGENT_NAME } from "../constants";

export const useRcAgentReady = () => {
	const { copilotkit } = useCopilotKit();

	const [agentReady, setAgentReady] = useState(() =>
		Boolean(copilotkit.getAgent(APPS_REDEEM_AGENT_NAME)),
	);

	useEffect(() => {
		const sync = () => {
			setAgentReady(Boolean(copilotkit.getAgent(APPS_REDEEM_AGENT_NAME)));
		};

		sync();
		const subscription = copilotkit.subscribe({
			onRuntimeConnectionStatusChanged: sync,
			onAgentsChanged: sync,
		});
		return () => subscription.unsubscribe();
	}, [copilotkit]);

	return agentReady;
};
